const ACCESS_TOKEN_KEY = 'accessToken'
const TOKEN_CHANGED = 'cardreplay:token-changed'
const notify = () => globalThis.dispatchEvent?.(new Event(TOKEN_CHANGED))

export const browserTokenStorage = {
  clear: () => {
    globalThis.localStorage?.removeItem(ACCESS_TOKEN_KEY)
    notify()
  },
  read: () => globalThis.localStorage?.getItem(ACCESS_TOKEN_KEY) ?? null,
  write: (token: string) => {
    globalThis.localStorage?.setItem(ACCESS_TOKEN_KEY, token)
    notify()
  },
  subscribe: (listener: () => void) => {
    globalThis.addEventListener('storage', listener)
    globalThis.addEventListener(TOKEN_CHANGED, listener)
    return () => {
      globalThis.removeEventListener('storage', listener)
      globalThis.removeEventListener(TOKEN_CHANGED, listener)
    }
  },
}
